import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

import { type FieldSuggestion } from 'hb-react/shared/components/AIFormWidget/types';

interface HistoryNavigationProps {
  onNavigate: (index: number) => void;
  suggestion: FieldSuggestion;
}

export const HistoryNavigation = ({
  suggestion,
  onNavigate,
}: HistoryNavigationProps) => {
  const history = suggestion.history || [];
  const currentIndex = suggestion.currentHistoryIndex ?? 0;

  if (history.length <= 1) {
    return null;
  }

  return (
    <Box alignItems="center" alignSelf="flex-end" gridColumnGap={2}>
      <Button
        size="small"
        variant="secondary"
        onClick={() => onNavigate(currentIndex - 1)}
        isDisabled={currentIndex <= 0}
        aria-label={s__('AIForm|Go to previous suggestion')}
        icon={() => (
          <FontAwesomeIcon
            iconName="chevron-left"
            height="12px"
            iconType={CATEGORIES.SOLID}
          />
        )}
      />

      <Box font="metadata-regular-asphalt" px={2}>
        {s__('AIForm|%{current} of %{total}').i__({
          current: String(currentIndex + 1),
          total: String(history.length),
        })}
      </Box>

      <Button
        size="small"
        variant="secondary"
        onClick={() => onNavigate(currentIndex + 1)}
        isDisabled={currentIndex >= history.length - 1}
        aria-label={s__('AIForm|Go to next suggestion')}
        icon={() => (
          <FontAwesomeIcon
            iconName="chevron-right"
            height="12px"
            iconType={CATEGORIES.SOLID}
          />
        )}
      />
    </Box>
  );
};
